import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

// Linear-style sequence shortcuts. Press G then a second key.
const MAP = {
  c: "/",
  d: "/discovery",
  i: "/inventory",
  r: "/runtime",
  h: "/oversight",
  a: "/audit",
  s: "/settings",
};

export default function useKeyboardShortcuts({ onHelp, onPalette } = {}) {
  const navigate = useNavigate();
  const pending = useRef(null);
  const timer = useRef(null);

  useEffect(() => {
    const isTyping = () => {
      const a = document.activeElement;
      if (!a) return false;
      const tag = a.tagName;
      return tag === "INPUT" || tag === "TEXTAREA" || a.isContentEditable;
    };

    const onKey = (e) => {
      if (isTyping()) return;
      if (e.metaKey || e.ctrlKey || e.altKey) return;

      const k = e.key.toLowerCase();

      if (k === "?" || (e.shiftKey && k === "/")) {
        e.preventDefault();
        onHelp?.();
        return;
      }

      if (pending.current === "g" && MAP[k]) {
        e.preventDefault();
        navigate(MAP[k]);
        pending.current = null;
        clearTimeout(timer.current);
        return;
      }

      if (k === "g") {
        pending.current = "g";
        clearTimeout(timer.current);
        timer.current = setTimeout(() => (pending.current = null), 1100);
      }
    };

    window.addEventListener("keydown", onKey);
    return () => {
      window.removeEventListener("keydown", onKey);
      clearTimeout(timer.current);
    };
  }, [navigate, onHelp, onPalette]);
}

export const SHORTCUTS = [
  { keys: "G C", label: "Go to Command Center" },
  { keys: "G D", label: "Go to AI Discovery" },
  { keys: "G I", label: "Go to AI Inventory" },
  { keys: "G R", label: "Go to Runtime Monitor" },
  { keys: "G H", label: "Go to Human Oversight" },
  { keys: "G A", label: "Go to Audit Center" },
  { keys: "G S", label: "Go to Settings" },
  { keys: "⌘ K", label: "Open command palette" },
  { keys: "?", label: "Show keyboard shortcuts" },
];
